import "./App.css";
import { Navigate, Route, Routes } from "react-router-dom";
import { useState } from "react";
import { LoggedInContainer } from "./Components/LoggedInContainer";
import { AirplaneRules } from "./Components/AirplaneRules";
import {
  getGroup,
  getToken,
  removeData,
  removeGroup,
  removeToken,
  removeUserId,
} from "./misc/tokens";
import { LoginScreen } from "./Screens/LoginScreen";
import { ForgotPasswordScreen } from "./Screens/ForgotPasswordScreen";
import { ResetPasswordScreen } from "./Screens/ResetPasswordScreen";
import { RegisterAccountScreen } from "./Screens/RegisterScreen";
import { StartScreen } from "./Screens/StartScreen";
import { AccountScreen } from "./Screens/AccountScreen";
import { RegisterSelectionScreen } from "./Screens/RegisterSelectionScreen";
import { PaymentHistory } from "./Screens/PaymentHistory";
import { FlightHistory } from "./Screens/FlightHistory";
import { BuyTokenScreen } from "./Screens/BuyTokensScreen";
import FlightScreen from "./Screens/FlightScreen";
import { ProcessPayment } from "./Screens/ProcessPayment";
import { PlaneScreen } from "./Screens/PlaneScreen";
import { GenericAdminScreen } from "./Screens/Admin/GenericAdminScreen";
import { RequestFlightScreen } from "./Screens/RequestFlightScreen";
import { RegisterSingleScreen } from "./Screens/RequestSingleFlightScreen";
import UserProfileScreen from "./Screens/UserProfileScreen";
import InvoiceScreen from "./Screens/InvoiceScreen";
import AdminInvoiceScreen from "./Components/AdminInvoiceSystem";
import AdminReportScreen from "./Components/AdminReportSystem";
import { PaymentReturnScreen } from "./Screens/PaymentReturnScreen";
import { LegalPage } from "./Screens/LegalPage";
import { Footer } from "./Components/Footer";
import { CookieBanner } from "./Screens/CookieBanner";
import { ENV_CONFIG } from "./misc/config";

function App() {
  const [isLoggedIn, setLoggedin] = useState(getToken());
  const [chx, setChx] = useState(false);
  const group = getGroup();
  const admin = group == 0;
  const dezurants = group == 100;
  const hasElevatedAccess = admin || dezurants;

  const Logout = () => {
    removeToken();
    removeGroup();
    removeData();
    removeUserId();
    setLoggedin(false);
    return <Navigate to="/login" />;
  };

  const RedirectWrapper = () => (
    <Navigate to={isLoggedIn ? "/main" : "/login"} />
  );

  const routeConfig = [
    { path: "/", component: StartScreen, public: true },
    {
      path: "/login",
      component: LoginScreen,
      public: true,
      customRender: true,
    },
    { path: "/register-single", component: RegisterSingleScreen, public: true },
    { path: "/forgot-password", component: ForgotPasswordScreen, public: true },
    { path: "/reset-password", component: ResetPasswordScreen, public: true },

    {
      path: "/register-options",
      component: RegisterSelectionScreen,
      public: true,
    },
    { path: "/e-pay/", component: ProcessPayment, public: true },
    { path: "/logout", component: Logout, public: true },

    { path: "/main", component: AccountScreen, protected: true },
    { path: "/request", component: RequestFlightScreen, protected: true },
    { path: "/flight-data", component: FlightScreen, elevated: true },
    { path: "/payment-history", component: PaymentHistory, protected: true },
    { path: "/flight-history", component: FlightHistory, protected: true },
    { path: "/buy-credits", component: BuyTokenScreen, protected: true },
    { path: "/planes", component: PlaneScreen, protected: true },
    { path: "/payment/return", component: PaymentReturnScreen, public: true },
    { path: "/legal/:type", component: LegalPage, public: true },

    {
      path: "/profile",
      component: UserProfileScreen,
      protected: true,
    },
    {
      path: "/invoices",
      component: InvoiceScreen,
      protected: true,
    },
    {
      path: "/rules",
      component: AirplaneRules,
      protected: true,
      props: {
        showRules: false,
        style: { marginTop: 100 },
        showCheckmark: chx,
      },
    },

    {
      path: "/admin",
      component: GenericAdminScreen,
      elevated: true,
      props: { type: "dashboard" },
    },
    {
      path: "/admin-subscription-packages",
      component: GenericAdminScreen,
      elevated: true,
      props: { type: "subscription-packages" },
    },
    {
      path: "/admin-requests",
      component: GenericAdminScreen,
      elevated: true,
      props: { type: "requests" },
    },
    {
      path: "/admin-questions",
      component: GenericAdminScreen,
      admin: true,
      props: { type: "questions" },
    },
    {
      path: "/admin-invoices",
      component: AdminInvoiceScreen,
      admin: true,
      props: { type: "questions" },
    },
    {
      path: "/admin-reports",
      component: AdminReportScreen,
      admin: true,
    },
    {
      path: "/admin-rules",
      component: GenericAdminScreen,
      admin: true,
      props: { type: "rules" },
    },
    {
      path: "/admin-users",
      component: GenericAdminScreen,
      admin: true,
      props: { type: "users" },
    },
    {
      path: "/admin-payments",
      component: GenericAdminScreen,
      elevated: true,
      props: { type: "payments" },
    },
    {
      path: "/admin-ppr-categories",
      component: GenericAdminScreen,
      admin: true,
      props: { type: "ppr-categories" },
    },
    {
      path: "/admin-stands",
      component: GenericAdminScreen,
      admin: true,
      props: { type: "stands" },
    },
    ...(ENV_CONFIG.ENABLE_REGISTRATION ? [{
      path: "/register-account",
      component: RegisterAccountScreen,
      public: true,
    }] : []),
  ];

  const renderRoute = (route, index) => {
    const { path, component: Component, props = {}, customRender } = route;
    const key = `route-${index}`;

    if (customRender && path === "/login") {
      return (
        <Route
          key={key}
          path={path}
          element={isLoggedIn ? <RedirectWrapper /> : <Component {...props} />}
        />
      );
    }

    const needsContainer = route.protected || route.admin || route.elevated;
    const needsAuth = route.protected || route.admin || route.elevated;
    const needsAdmin = route.admin;
    const needsElevated = route.elevated;

    if (needsAuth && !isLoggedIn) return null;
    if (needsAdmin && !admin) return null;
    if (needsElevated && !hasElevatedAccess) return null;

    let element = <Component {...props} />;

    if (needsContainer) {
      element = (
        <>
          <LoggedInContainer setTr={setChx} tr={chx}>
            {element}
          </LoggedInContainer>
          <Footer isLoggedIn={isLoggedIn} />
        </>
      );
    }

    return <Route key={key} path={path} element={element} />;
  };

  return (
    <>
      <Routes>
        {routeConfig.map((route, index) => renderRoute(route, index))}

        <Route path="*" element={<RedirectWrapper />} />
      </Routes>
      <CookieBanner />
      {!isLoggedIn && <Footer />}
    </>
  );
}

export default App;